module.exports = __webpack_public_path__ + "img/pelvis.17a883ac.png";